module.exports = __webpack_public_path__ + "static/media/bandHuntWeb.d1247302.webp";